import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Flame, Loader2, ArrowRightCircle, CheckCircle2 } from "lucide-react";
import { api } from "../../lib/api";

const NIVEL = {
  Caliente: { color: "text-destructive", bar: "bg-destructive" },
  Tibio: { color: "text-amber-500", bar: "bg-amber-500" },
  "Frío": { color: "text-sky-500", bar: "bg-sky-500" },
};

export default function ModuleLeadScore({ moduleKey, item, onRefresh }) {
  const [busy, setBusy] = useState(false);
  const score = item.lead_score ?? 0;
  const nivel = item.lead_nivel || "Frío";
  const style = NIVEL[nivel] || NIVEL["Frío"];
  const converted = !!item.opportunity_id;

  const convert = async () => {
    setBusy(true);
    try {
      await api.post(`/mod/${moduleKey}/items/${item.id}/convert`);
      toast.success("Lead convertido a Oportunidad en Sales CRM");
      onRefresh?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 border-t border-navy/10 pt-4 space-y-3" data-testid="module-leadscore">
      <div className="flex items-center gap-2 overline text-navy/40"><Flame className="w-3.5 h-3.5" /> Lead Score (automático)</div>
      <div className="flex items-center gap-4">
        <div className="text-center">
          <div className={`font-editorial text-4xl ${style.color}`} data-testid="lead-score">{score}</div>
          <div className={`text-xs font-medium ${style.color}`} data-testid="lead-nivel">{nivel}</div>
        </div>
        <div className="flex-1">
          <div className="h-2 rounded-full bg-navy/10 overflow-hidden"><div className={`h-full ${style.bar}`} style={{ width: `${score}%` }} /></div>
          <p className="text-[11px] text-navy/40 mt-1.5">Calculado desde interés, fuente, interacciones y presupuesto.</p>
        </div>
      </div>

      {converted ? (
        <Link to="/os/mod/opportunities" className="btn btn-ghost w-full justify-center text-emerald-600" data-testid="lead-converted">
          <CheckCircle2 className="w-4 h-4" /> Convertido — ver Oportunidad
        </Link>
      ) : (
        <button onClick={convert} disabled={busy} className="btn btn-primary w-full justify-center" data-testid="lead-convert-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRightCircle className="w-4 h-4" />} Convertir a Oportunidad
        </button>
      )}
    </div>
  );
}
